var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spotify",
    clipPath: "url(#clip0_8982_2674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0993 0.541016C6.21704 0.541016 0.637573 6.12033 0.637573 13.0026C0.637573 19.8852 6.21704 25.4641 13.0993 25.4641C19.9824 25.4641 25.5612 19.8852 25.5612 13.0026C25.5612 6.12078 19.9824 0.541611 13.0992 0.541611L13.0993 0.541016ZM18.8142 18.5142C18.591 18.8803 18.1118 18.9964 17.7458 18.7717C14.8199 16.9845 11.1365 16.5797 6.79873 17.5708C6.38073 17.666 5.96406 17.4041 5.86882 16.986C5.77314 16.5678 6.034 16.1511 6.45305 16.0559C11.2001 14.9709 15.2719 15.4383 18.5568 17.4458C18.9228 17.6705 19.0389 18.1482 18.8142 18.5142ZM20.3395 15.1206C20.0583 15.5782 19.46 15.7226 19.0032 15.4413C15.6535 13.3819 10.5474 12.7857 6.58534 13.9883C6.0715 14.1435 5.52879 13.854 5.37284 13.341C5.21808 12.8272 5.50781 12.2855 6.02076 12.1293C10.5465 10.756 16.1728 11.4212 20.0196 13.7851C20.4764 14.0663 20.6208 14.6645 20.3395 15.1208V15.1206ZM20.4705 11.5873C16.4541 9.20173 9.8276 8.98238 5.99293 10.1462C5.37716 10.333 4.72597 9.98536 4.53936 9.36959C4.35275 8.75351 4.70007 8.10277 5.31629 7.91557C9.71823 6.57926 17.0359 6.83744 21.66 9.58253C22.2151 9.91125 22.3967 10.6266 22.0678 11.1797C21.7404 11.7336 21.0231 11.9162 20.4711 11.5873H20.4705Z",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8982_2674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.599976 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.b03b7dc287f408b8aa8c773c90b6aabf.svg";
export { ForwardRef as ReactComponent };